import React from "react";
import SimpleFooter from "./SimpleFooter";

const Footer = (props) => <SimpleFooter {...props} />;
export default Footer;
